import React, { useState } from "react";
import solana from "../images/icons/solana.png";
import ethActive from "../images/icons/ethActive.png";
import userImage from "../images/userImage.png";

import { trimCharsDynamic } from "../utils/utils";

const UserInfo = ({ token, address, type }) => {
  return (
    <div
      className={`flex  gap-2 items-center  w-full relative  py-4 ${
        type === "ETH" ? "flex-row-reverse" : ""
      }`}
    >
      <div className="flex flex-col ">
        <div
          className={`flex items-center gap-2  ${
            type === "ETH" ? "justify-start" : "justify-end"
          }`}
        >
          <img src={type === "SOL" ? solana : ethActive} alt="" />
          <span className="text-[13px] font-normal tracking-[0.26px] text-white">
            {!token || !address ? "NOT CONNECTED" : "CONNECTED"}
          </span>
        </div>
        <div className="text-[18px] font-normal flex justify-end">
          {trimCharsDynamic(address, 5)}
        </div>
      </div>
      <div className="">
        <img src={userImage} alt="" />
      </div>
    </div>
  );
};

export default UserInfo;
